<template>
  <!--
    <div class="peers ai-s fxw-nw h-100vh">
        <div class="d-n@sm- peer peer-greed h-100 pos-r bgr-n bgpX-c bgpY-c bgsz-cv" style='background-image: url("/images/bg.jpg")'>
        </div>
        <div class="col-12 col-md-4 peer pX-40 pY-80 h-100 bgc-white scrollable pos-r" style='min-width: 320px;'>
            <h4 class="fw-300 c-grey-900 mB-40">Befeni Production System Login</h4>

            <div class="alert alert-danger" v-if="error">
                <p>There was an error, unable to sign in with those credentials.</p>
            </div>

            <form autocomplete="off" @submit.prevent="login" method="post">
                <div class="form-control-group">
                    <label class="text-normal text-dark">Username</label>
                    <input type="email" id="email" class="form-control" placeholder="user@example.com" v-model="email" required>
                </div>
                <div class="form-group">
                    <label class="text-normal text-dark">Password</label>
                    <input type="password" id="password" class="form-control" v-model="password" required>
                </div>
                <div class="form-group">
                    <div class="peers ai-c jc-sb fxw-nw">
                        <div class="peer">
                            <button class="btn btn-primary">Login</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>-->
  <div class="container">
    <div class="row login-container column-seperation">
      <div class="col-md-5 col-md-offset-1">
        <br />
        <img src="/assets/img/logo-black.png" height="70" />
        <h3><span class="bold">Production System</span> Login</h3>
        <p>
          Welcome to the Befeni Production System. Login to the system with your
          credentials opposite.
        </p>
      </div>
      <div class="col-md-5">
        <br />

        <div class="alert alert-danger" v-if="error">
          <p>There was an error, unable to sign in with those credentials.</p>
        </div>

        <form autocomplete="off" @submit.prevent="login" method="post">
          <div class="row">
            <div class="form-group col-md-10">
              <label class="form-label">Username</label>
              <div class="controls">
                <div class="input-with-icon right">
                  <i class=""></i>
                  <input
                    type="email"
                    id="email"
                    class="form-control"
                    placeholder="user@example.com"
                    v-model="email"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-10">
              <label class="form-label">Password</label>
              <span class="help"></span>
              <div class="controls">
                <div class="input-with-icon right">
                  <i class=""></i>
                  <input
                    type="password"
                    id="password"
                    class="form-control"
                    v-model="password"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-10">
              <button class="btn btn-primary btn-cons pull-right" type="submit">
                Login
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      email: null,
      password: null,
      error: false,
    };
  },
  methods: {
    login() {
      var app = this;
      this.$auth.login({
        data: {
          email: app.email,
          password: app.password,
        },
        success: function (response) {
          /**
           * This token used to be stored in the cookies, but cookies have limited size of 4096 bytes.
           * Whereas the token follow the JWT format: header + payload + signature (https://jwt.io/) and can be quite big.
           */
          localStorage.setItem(
            "authorization",
            response.headers["authorization-v2"]
          );
          if($Fabric.isFabricSystemUser(this.$auth.user())) {
            this.$router.push('/fabric/dashboard')
          }
          if($Fabric.isFabricInventoryUser(this.$auth.user())) {
            this.$router.push('/fabric/listing/inventory')
          }
          this.$router.push('/shirt/dashboard')
        },
        error: function () {
          this.error = true;
        },
        rememberMe: true,
        fetchUser: true,
      });
    },
  },
};
</script>
